'use client'
import {styled} from "@phntms/css-components";
import styles from "./styles.module.scss";
//import Image from "next/image";
//import CardsGroupsSection from "../../sections/CardsGroupsSection/index";
//import ReactPlayer from 'react-player/file';

export const CardsGroupsSectionContainer = styled('section' , {
  css: [styles.groupedCardsSection, 'container', 'countries-section', 'cards-groups-section']
})





